export const versions = {
  version: "1.0.183",
  revision: "edfb211cf",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-4881-gedfb211cf-dirty",
    hash: "gedfb211cf",
    distance: 4881,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "4881-gedfb211cf-dirty",
    semverString: "1.0.183+4881.gedfb211cf.dirty"
  }
};
